import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ClickOutside from 'vue-click-outside'
import {
	setupGlobalToPage,
	toPage
} from '@/utils/tool'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/common.scss'
import '@/assets/css/utils.scss'

// import '@/assets/pool/index.css'
// import '@/assets/pool/main.css'
// import '@/assets/pool/pool_index.css'

import '@/utils/registerGlobalComponents.js'
import BaiduMap from "vue-baidu-map";

// 引入事件总线
import bus from '@/utils/bus'
// 引入登录弹窗组件
import GlobalLoginModal from '@/components/GlobalLoginModal.vue'
// 引入vip购买弹窗组件
// import VipBuy from '@/components/VipBuy.vue'


Vue.use(ElementUI)

Vue.use(BaiduMap, {
	ak: "GXNHKPKk6Q3PxPOXuosb4USyTkXNPdFx", // 百度地图密钥
	// n4EYelzHPkSXAS9spLkBxaZblLDy7C9m
})

Vue.directive('click-outside', ClickOutside)

// 全局挂载事件总线
Vue.prototype.$bus = bus
// 全局挂载 toPage 方法
Vue.prototype.$toPage = toPage
// 全局注册登录弹窗组件
Vue.component('GlobalLoginModal', GlobalLoginModal)
// Vue.component('VipBuy', VipBuy)
Vue.config.productionTip = false

Vue.filter('joinNonEmpty', function(arr, separator = ' | ') {
	return arr.filter(item => !!item).join(separator)
})


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')